import { SVGProps } from '@components/Icon/types';

export const H3 = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.1616, 4.92)">
      <path
        d="M17.0664 14C16.3861 14 15.7535 13.876 15.1686 13.6281C14.5837 13.3737 14.0782 13.0177 13.6522 12.5599C13.2326 12.0958 12.9243 11.5459 12.7272 10.9101L14.3579 10.4428C14.5678 11.0786 14.9174 11.5618 15.407 11.8924C15.8966 12.223 16.4465 12.3851 17.0569 12.3787C17.6163 12.366 18.0995 12.2389 18.5065 11.9973C18.9197 11.7493 19.2376 11.4124 19.4601 10.9864C19.689 10.5604 19.8035 10.0677 19.8035 9.50817C19.8035 8.65622 19.5491 7.96639 19.0405 7.43869C18.5319 6.90463 17.8643 6.6376 17.0378 6.6376C16.8089 6.6376 16.5673 6.66939 16.313 6.73297C16.065 6.79655 15.833 6.88556 15.6168 7L14.7966 5.65531L19.8893 1.04905L20.1086 1.62125H13.2708V0H21.3675V1.63079L17.0282 5.78883L17.0092 5.18801C17.9183 5.12443 18.7131 5.27384 19.3934 5.63624C20.0737 5.99864 20.6014 6.5168 20.9765 7.19074C21.3579 7.86467 21.5487 8.63715 21.5487 9.50817C21.5487 10.3856 21.3516 11.1612 20.9574 11.8351C20.5632 12.5091 20.0292 13.04 19.3552 13.4278C18.6813 13.8093 17.9183 14 17.0664 14Z"
        fill={fill}
      />
      <path
        d="M0 13.733V0H1.69755V6.05586H8.92643V0H10.624V13.733H8.92643V7.66757H1.69755V13.733H0Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'h3';
